import type { ReactNode } from 'react';
import { Checkbox as AriaCheckbox, Switch as AriaSwitch } from 'react-aria-components';
import { joinClasses, rowClass } from './Field';
import { Icon } from './Icon';

export interface ToggleProps {
  isSelected: boolean;
  onChange: (selected: boolean) => void;
  children: ReactNode;
  isDisabled?: boolean;
  className?: string;
}

// The tick is the icon set's `check`, drawn in currentColor — not a text glyph.
const boxClass =
  'flex items-center justify-center w-4 h-4 m-0 p-0 border border-line-strong rounded-[4px] bg-surface text-surface group-data-[selected]:bg-ink group-data-[selected]:border-ink group-data-[focus-visible]:outline-2 group-data-[focus-visible]:outline-offset-2 group-data-[focus-visible]:outline-ink';

export function Checkbox({ isSelected, onChange, children, isDisabled, className }: ToggleProps) {
  return (
    <AriaCheckbox
      isSelected={isSelected}
      onChange={onChange}
      isDisabled={isDisabled}
      className={joinClasses('group', rowClass, className)}
    >
      <span aria-hidden="true" className={boxClass}>
        {isSelected ? <Icon name="check" size={14} /> : null}
      </span>
      {children}
    </AriaCheckbox>
  );
}

export function Switch({ isSelected, onChange, children, isDisabled, className }: ToggleProps) {
  return (
    <AriaSwitch
      isSelected={isSelected}
      onChange={onChange}
      isDisabled={isDisabled}
      className={joinClasses('group', rowClass, className)}
    >
      <span
        aria-hidden="true"
        className="flex items-center w-7 h-4 m-0 p-[2px] border border-line-strong rounded-pill bg-surface group-data-[selected]:bg-ink group-data-[selected]:border-ink group-data-[selected]:justify-end group-data-[focus-visible]:outline-2 group-data-[focus-visible]:outline-offset-2 group-data-[focus-visible]:outline-ink"
      >
        <span className="block w-[10px] h-[10px] m-0 p-0 rounded-pill bg-line-strong group-data-[selected]:bg-surface" />
      </span>
      {children}
    </AriaSwitch>
  );
}
